import { classNames } from "../../../util";
import {
  resetModuleSearch,
  SEARCH_RESULTS_LABEL,
} from "../../../util/usePersistedFilterFormik";

export const Tabs = props => {
  const { tabs, active, onChange } = props || [];
  const handleChange = name => {
    const tab = tabs?.find(item => item?.name === name);
    if (name === "all" && tab?.label !== SEARCH_RESULTS_LABEL) {
      resetModuleSearch(window.location.pathname);
    }
    onChange(name);
  };
  return (
    <div>
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        <select
          id="tabs"
          name="tabs"
          className="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"
          value={active || ""}
          onChange={event => handleChange(event.target.value)}
        >
          {tabs?.map(tab => (
            <option key={tab.label} value={tab.name}>
              {tab.label}
            </option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <nav className="flex space-x-4" aria-label="Tabs">
          {tabs?.map((tab, index) => (
            <a
              key={tab.label}
              onClick={() => handleChange(tab?.name)}
              className={classNames(
                tab.name == active
                  ? "text-black underline underline-offset-1"
                  : "text-gray-400",
                `cursor-pointer rounded-md px-3 py-2 text-sm font-bold ${index === 0 ? "pl-0" : ""}`,
              )}
              aria-current={active ? "page" : undefined}
            >
              {tab.label}
            </a>
          ))}
        </nav>
      </div>
    </div>
  );
};
